// @flow

import {DateTime} from 'luxon';

export const getTimeWithLocale = (
  input: Date | number | string,
  locale: string,
) => {
  let dt;
  if (typeof input === 'object') {
    dt = DateTime.fromJSDate(input);
  } else if (typeof input === 'string') {
    dt = DateTime.fromISO(input);
  } else {
    dt = DateTime.fromMillis(input);
  }
  return dt.setLocale(locale);
};
